module.exports = __webpack_public_path__ + "img/data.9e1ea1a5.png";